
import { useState } from 'react';

export default function Order() {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappNumber = '5519971394274';
  const whatsappMessage = encodeURIComponent('Olá! Gostaria de fazer um pedido no Buckets Chicken! 🍗');

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  return (
    <section id="order" className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-red-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-4">
            FAÇA SEU PEDIDO
          </h2>
          <div className="w-24 md:w-32 h-2 bg-yellow-400 mx-auto rounded-full"></div>
          <p className="text-gray-800 text-base md:text-xl mt-4 md:mt-6">Delivery rápido e fácil pelo WhatsApp!</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-3xl p-6 sm:p-8 md:p-12 shadow-2xl">
            <div className="text-center mb-8 md:mb-12">
              <div className="inline-block bg-white rounded-full p-4 md:p-6 mb-4 md:mb-6 shadow-lg">
                <img
                  src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/a5bb4558efa960a1896a0fe4ecddc296.png"
                  alt="Buckets Chicken"
                  className="h-16 w-16 md:h-24 md:w-24 object-contain"
                />
              </div>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-white mb-3 md:mb-4 px-2">
                Peça pelo WhatsApp e receba em casa!
              </h3>
              <p className="text-white text-sm md:text-lg px-2">
                Atendimento rápido, entrega garantida e frango sempre crocante!
              </p>
            </div>

            <div className="flex justify-center mb-8 md:mb-12">
              <button
                onClick={handleWhatsAppClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={`group relative bg-gradient-to-r from-green-400 to-green-500 text-white px-8 sm:px-12 md:px-16 py-5 md:py-8 rounded-full text-xl sm:text-2xl md:text-3xl font-black shadow-2xl transition-all duration-300 whitespace-nowrap overflow-hidden cursor-pointer ${
                  isHovered ? 'scale-110 shadow-green-400/50' : 'scale-100'
                }`}
              >
                <span className="relative z-10 flex items-center justify-center gap-3 md:gap-4">
                  <i className={`ri-whatsapp-fill text-3xl md:text-5xl transition-transform duration-300 ${isHovered ? 'rotate-12 scale-110' : ''}`}></i>
                  PEDIR NO WHATSAPP
                  <i className={`ri-arrow-right-line text-2xl md:text-4xl transition-transform duration-300 ${isHovered ? 'translate-x-3' : ''}`}></i>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center border-2 border-white/20">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-message-3-fill text-2xl md:text-3xl text-black"></i>
                </div>
                <h4 className="text-white font-bold text-base md:text-lg mb-1 md:mb-2">1. Envie Mensagem</h4>
                <p className="text-white/80 text-xs md:text-sm">Clique no botão e fale conosco</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center border-2 border-white/20">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-restaurant-fill text-2xl md:text-3xl text-black"></i>
                </div>
                <h4 className="text-white font-bold text-base md:text-lg mb-1 md:mb-2">2. Escolha seu Pedido</h4>
                <p className="text-white/80 text-xs md:text-sm">Monte seu combo favorito</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center border-2 border-white/20">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-e-bike-2-fill text-2xl md:text-3xl text-black"></i>
                </div>
                <h4 className="text-white font-bold text-base md:text-lg mb-1 md:mb-2">3. Receba em Casa</h4>
                <p className="text-white/80 text-xs md:text-sm">Entrega rápida e segura</p>
              </div>
            </div>
          </div>

          <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            <div className="bg-red-600 rounded-2xl p-6 md:p-8 text-center">
              <i className="ri-time-fill text-4xl md:text-5xl text-yellow-400 mb-3 md:mb-4"></i>
              <h4 className="text-white font-bold text-lg md:text-xl mb-2">Horário de Funcionamento</h4>
              <p className="text-white text-sm md:text-base">Segunda a Domingo</p>
              <p className="text-yellow-400 font-bold text-xl md:text-2xl mt-2">11h às 23h</p>
            </div>

            <div className="bg-black rounded-2xl p-6 md:p-8 text-center">
              <i className="ri-map-pin-fill text-4xl md:text-5xl text-yellow-400 mb-3 md:mb-4"></i>
              <h4 className="text-white font-bold text-lg md:text-xl mb-2">Área de Entrega</h4>
              <p className="text-white text-sm md:text-base">Consulte disponibilidade</p>
              <p className="text-yellow-400 font-bold text-xl md:text-2xl mt-2">para sua região</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
